import axios from '@/libs/axios'

export default {
    namespaced: true,

    state: {
        packages: []
    },

    getters: {
        packages(state) {
            return state.packages
        }
    },

    mutations: {
        SET_PACKAGES(state, value) {
            state.packages = value
        },
        UPDATE_PACKAGE(state, data) {
            const index = state.packages.findIndex(unitPackage => unitPackage.id == data.id);
            Object.assign(state.packages[index], data);//Object.fromEntries(data)
        },
        ADD_PACKAGE(state, data) {
            state.packages.push(data); //= {...state.packages, ...data};
        },
        DELETE_PACKAGE(state, id) {
            const index = state.packages.findIndex(unitPackage => unitPackage.id === id)
            state.packages.splice(index, 1)
        },
    },

    actions: {
        loadPackages({ commit }) {
            return axios.get('api/packages').then(response => {
                commit('SET_PACKAGES', response.data.data)
            })
        },
        updatePackage({ commit }, data ) {
            return axios.put(`api/packages/${data.id}`, data).then((response) => {
                commit('UPDATE_PACKAGE', response.data.data)
            })
        },
        addPackage({ commit }, data ) {
            return axios.post('api/packages', data).then((response) => {
                commit('ADD_PACKAGE', response.data.data )
            })
        },
        deletePackage({ commit }, id) {
            return axios.delete(`api/packages/${id}`).then(() => {
                commit('DELETE_PACKAGE', id)
            })
        },
    },
}
